import { types } from '../../../types/types';

export const reducerEventos = (state = {}, action = {}) => {
    let result = {};
    switch (action.type) {
        case types.EVENTO.DADOSEVENTO:
            result = action.payload;
            break;    
        default:
            result = state;
            break;
    }
    return result;
}

export const reducerDadosWebEvento = (state = {}, action = {}) => {
    let result = {};
    switch (action.type) {
        case types.EVENTO.DADOSWEBEVENTO:
            result = action.payload;
            break;    
        default:
            result = state;
            break;
    }
    return result;
}

export const reducerPesquisaEventos = (state = [], action = {}) => {
    let result = [];    
    switch (action.type) {
        case types.EVENTO.PESQUISADADOSEVENTO:            
            result = action.payload;
            break;    
        default:
            result = state;
            break;
    }
    return result;
}

export const reducerCadastroEvento = (state = {}, action = {}) => {
    let result = {};
    switch (action.type) {
        case types.EVENTO.CADASTRADO:
            result = action.payload;
            break;    
        default:
            result = state;
            break;
    }
    return result;
}

export const reducerEventoSelecionado = (state = {}, action = {}) => {
    let result = {};
    switch (action.type) {
        case types.EVENTO.EVENTOSELECTED:
            result = action.payload;
            break;    
        default:
            result = state;
            break;
    }
    return result;
}